<template>
  <div class="part2" :style="bg">
    <div class="contentWrap" v-if="active == 1">
      <div class="animate__animated animate__fadeIn line">
        <img src="../assets/index/line.png" alt="" />
      </div>
      <div class="title1 animate__animated animate__fadeIn">
        {{ one_title }}
      </div>
      <div class="title2 animate__animated animate__fadeIn delay1">
        {{ one_desc }}
      </div>
      <div class="title3 animate__animated animate__fadeIn delay2">
        {{ one_content }}
      </div>

      <div class="bottomWrap">
        <!-- changeBg(1); -->

        <div
          v-for="(item, index) in onelist"
          :key="index"
          @mouseover="handleMouse(index, item)"
          class="item animate__animated animate__fadeIn"
        >
          <div class="logo animate__animated animate__fadeIn">
            <img
              :src="oneactive == index ? item.hover_image : item.image"
              alt=""
            />
          </div>
          <div class="title animate__animated animate__fadeIn">
            {{ item.title }}
          </div>
          <div class="desc delay2">
            {{ item.desc }}
          </div>
          <div class="line"></div>
        </div>
        <!-- <div
          class="item animate__animated animate__fadeIn delay2"
          @mouseover="(gjrz = require('../assets/index/2-a.png')), changeBg(2)"
          @mouseleave="gjrz = require('../assets/index/2.png')"
        >
          <div class="logo animate__animated animate__fadeIn">
            <img :src="gjrz" alt="" />
          </div>
          <div class="title animate__animated animate__fadeIn delay1">
            国家认证
          </div>
          <div class="desc">
            国家高新技术企业认证 <br />
            国家康居认证、产品研发专利近百项
          </div>
          <div class="line"></div>
        </div>
        <div
          class="item animate__animated animate__fadeIn delay3"
          @mouseover="(qgwl = require('../assets/index/3-a.png')), changeBg(3)"
          @mouseleave="qgwl = require('../assets/index/3.png')"
        >
          <div class="logo animate__animated animate__fadeIn">
            <img :src="qgwl" alt="" />
          </div>
          <div class="title animate__animated animate__fadeIn delay1">
            全国网络
          </div>
          <div class="desc">
            全国拥有服务商100余家 <br />
            终端用户遍布全国各地
          </div>
          <div class="line"></div>
        </div>
        <div
          class="item animate__animated animate__fadeIn delay4"
          @mouseover="(khwx = require('../assets/index/4-a.png')), changeBg(4)"
          @mouseleave="khwx = require('../assets/index/4.png')"
        >
          <div class="logo animate__animated animate__fadeIn">
            <img :src="khwx" alt="" />
          </div>
          <div class="title animate__animated animate__fadeIn delay1">
            客户为先
          </div>
          <div class="desc">
            专注、创新、利他、责任 <br />
            将“服务至上”作为立企之本
          </div>
          <div class="line"></div>
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
import { index } from "../api/request";

export default {
  name: "Part2",
  props: {
    index: {
      default: 1,
    },
  },
  data() {
    return {
      bg: {
        backgroundImage: "url(" + require("../assets/index/part2-1.png") + ")",
        backgroundSize: "cover",
        backgroundPosition: "center center",
        backgroundCover: "cover",
      },
      active: "",
      ppbj: require("../assets/index/1.png"),
      gjrz: require("../assets/index/2.png"),
      qgwl: require("../assets/index/3.png"),
      khwx: require("../assets/index/4.png"),

      one_title: "",
      one_desc: "",
      one_content: "",
      oneactive: 0,
      onelist: [],
    };
  },
  methods: {
    // changeBg(index) {
    //   console.log(index);
    //   this.bg.backgroundImage =
    //     "url(" + require("../assets/index/part2-" + index + ".png") + ")";
    // },
    handleMouse(index, item) {
      this.oneactive = index;
      // console.log(item);
      this.bg = {
        backgroundImage: `url(${item.bg_image})`,
        backgroundSize: "cover",
        backgroundPosition: "center center",
        backgroundCover: "cover",
      };
    },
  },
  mounted() {
    index().then((res) => {
      if (res.data.code == 1) {
        // console.log(res.data.data);
        this.one_title = res.data.data.one_title;
        this.one_content = res.data.data.one_content;
        this.one_desc = res.data.data.one_desc;
        this.onelist = res.data.data.one;
      }
    });
  },
  watch: {
    index(val) {
      // console.log(val);
      this.active = val;
    },
  },
};
</script>

<style scoped lang="less">
.part2 {
  font-family: 微软雅黑, MicrosoftYaHei;
  color: #ffffff;
  width: 100%;
  height: 100vh;
  overflow: hidden;
  position: relative;
  .bg {
    position: absolute;
    width: 100%;
    height: 100vh;
    top: 0;
    left: 0;
  }
  .contentWrap {
    text-align: left;
    padding: 204px 0 0 13%;
    .title1 {
      margin-top: 44px;
      font-size: 42px;
    }
    .title2 {
      margin-top: 32px;
      font-size: 60px;
      font-weight: bold;
    }
    .title3 {
      margin-top: 32px;
      font-size: 24px;
    }
    .bottomWrap {
      margin-top: 92px;
      display: flex;
      align-items: center;
      .item {
        margin-right: 42px;
        width: 298px;
        .logo {
          width: 80px;
          height: 80px;
          img {
            width: 100%;
            height: 100%;
          }
        }
        .title {
          font-weight: bold;
          font-size: 30px;
          margin-top: 29px;
        }
        .desc {
          width: 298px;
          margin-top: 38px;
          font-size: 18px;
          line-height: 36px;
          opacity: 0;
        }
        .line {
          width: 0px;
          height: 1px;
          background: #ffffff;
          border-radius: 10px;
          margin-top: 43px;
        }
        &:hover .desc {
          animation: fadeInAnimation ease 1s;
          animation-iteration-count: 1; /*设置动画播放次数*/
          animation-fill-mode: forwards; /*设置样式以在动画不播放时应用元素。forward是设置动画结束后，使用元素的结束属性值*/
        }
        &:hover .line {
          width: 298px;
          transition: width 1s;
        }
      }
    }
  }
}
@media screen and (max-width: 450px) {
  .part2 {
    .contentWrap {
      .line {
        width: 90 * 2px;
        height: 8px * 2px;
        img {
          width: 90 * 2px;
          height: 8px * 2px;
        }
      }
      .title1 {
        margin-top: 88px;
        font-size: 42 * 2px;
      }
      .title2 {
        width: 60%;
        margin-top: 32 * 2px;
        font-size: 60 * 2px;
        font-weight: bold;
      }
      .title3 {
        margin-top: 32 * 2px;
        font-size: 24 * 2px;
      }
      .bottomWrap {
        margin-top: 92 * 2px;
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        .item {
          margin-right: 42px;
          width: 660px;
          height: 660px;
          .logo {
            width: 160px;
            height: 160px;
            img {
              width: 100%;
              height: 100%;
            }
          }
          .title {
            font-weight: bold;
            font-size: 60px;
            margin-top: 29px;
          }
          .desc {
            width: 600px;
            margin-top: 38px;
            font-size: 36px;
            line-height: 36 * 2px;
            opacity: 0;
          }
          .line {
            width: 0px;
            height: 1px;
            background: #ffffff;
            border-radius: 10px;
            margin-top: 43px;
          }
          &:hover .desc {
            animation: fadeInAnimation ease 1s;
            animation-iteration-count: 1; /*设置动画播放次数*/
            animation-fill-mode: forwards; /*设置样式以在动画不播放时应用元素。forward是设置动画结束后，使用元素的结束属性值*/
          }
          &:hover .line {
            width: 600px;
            transition: width 1s;
          }
        }
      }
    }
  }
}

@keyframes fadeInAnimation {
  0% {
    opacity: 0; /*设置不透明度*/
  }

  100% {
    opacity: 1;
  }
}
</style>
